import duDatepicker from '@dmuy/datepicker';

class OTODatePicker
{
  constructor(el) {
    this.el = el;
    this.dateInput = el.querySelector('.oto-date-field input[type="date"]');
    if (this.dateInput) {
      this.addDatePickerWidget();
    }
  }

  addDatePickerWidget() {

    // We want to just use native <input type="date"> on browsers that support it
    // But if they dont: we use a custom solution and disable manual date entry
    if (!window.OtOChecks.date) {

      // Initialise datepicker on input field
      var $this = this;
      duDatepicker(this.dateInput, {format: 'yyyy-mm-dd'});

      // Handle input click
      this.dateInput.addEventListener('click', function() {
        duDatepicker($this.dateInput, 'show');
      });

      // Handle icon click
      var icon = this.el.querySelector('input[type=date] ~ .mdc-text-field__icon');
      icon.addEventListener('click', function() {
        duDatepicker($this.dateInput, 'show');
      });

    }
    // Native date is supported, including calendar widget
    else {
      // Add a class to indicate native calendar
      this.el.classList.add('date-input-native');
    }
  }
}

window.addEventListener("DOMContentLoaded", function() {
  var dateFields = document.querySelectorAll('.mdc-date-field');
  if (dateFields.length) {
    dateFields.forEach(function(field) {
      new OTODatePicker(field);
    });
  }
  window.Livewire.hook('message.processed', function(el) {
    var liveWireFields = el.component.el.querySelectorAll('.mdc-date-field');
    if (liveWireFields.length) {
      liveWireFields.forEach(function(field) {
        new OTODatePicker(field);
      });
    }
  });
});

// Check if this browser supports native date functionality
const checkDateSupport = () => {
  const type = 'date';
  // Check date field support in browser
  const input = document.createElement("input");
  input.setAttribute("type", type);
  const supportsDateInput = (input.type == type);

  // Sometimes the date field is 'supported' but doesn't actually enforce a date
  const nonDate = 'non-date';
  input.value = nonDate;
  const supportsDateValue = input.value !== nonDate;

  return supportsDateInput && supportsDateValue;
}

window.OtOChecks = window.OtOChecks || {};

window.OtOChecks.date = checkDateSupport();
